import { render, staticRenderFns } from "./video-count-down-award-log.vue?vue&type=template&id=328dc461&scoped=true"
import script from "./video-count-down-award-log.vue?vue&type=script&lang=js"
export * from "./video-count-down-award-log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328dc461",
  null
  
)

export default component.exports